export { SearchInput, type SearchInputProps } from './SearchInput'
export { mapMostSearchedProducts, mapSearchProduct } from './mapSearchProduct'
export type { TopSearch, SearchProduct, SearchProductApiItem, SearchModuleData } from './types'
